export default __webpack_public_path__ + "a142c3b672d7dcf7274aee495112885d.png";